(function () {
  // The "Filter" drawer (blocks/filters.liquid #filters-drawer) renders
  // Sort by AFTER every filter category (price, size, color, …) — on a
  // long filter list that pushes it well below the fold. Move it to be the
  // first thing inside the scrollable drawer body instead.
  //
  // Can't just reorder the liquid source (core Horizon block, not ours),
  // so this moves it in the DOM. facets-form-component replaces the
  // drawer's inner HTML on every filter interaction (AJAX), which would
  // silently undo a one-time move — a MutationObserver re-applies it
  // whenever the drawer's content changes, not just on first load.
  function moveSortFirst(drawer) {
    var scrollHint = drawer.querySelector('.facets-drawer__filters');
    if (!scrollHint) return;
    var sortEl = scrollHint.querySelector('.sorting-filter');
    if (!sortEl) return;
    if (scrollHint.firstElementChild !== sortEl) {
      scrollHint.insertBefore(sortEl, scrollHint.firstElementChild);
    }
  }

  function init() {
    var drawer = document.getElementById('filters-drawer');
    if (!drawer) return;
    moveSortFirst(drawer);
    var mo = new MutationObserver(function () { moveSortFirst(drawer); });
    mo.observe(drawer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
